const finicityAutoScript = (() => {
  let promiseResolve;
  let finicityDefaultConfig = {};
  let widgetPromise = () => {
    return new Promise((resolve, reject) => {
      promiseResolve = resolve;
    });
  }


  /**
   * main : returning finicity HTML with config
   *
   * @author Gaurav <gaurav.babu@biz2credit.com>
   *
   * @param obj object
   */
  const main = (obj) => {
    initScript.toggleLoader(true);
    Object.assign(finicityDefaultConfig, obj);
    finicityDefaultConfig.security_option = !!finicityDefaultConfig.body.security ? finicityDefaultConfig.body.security : {};
    finicityDefaultConfig.slugs_flag = !!finicityDefaultConfig.slugs;
    finicityDefaultConfig.slugs = finicityDefaultConfig.slugs || {};
    finicityDefaultConfig.showFirstModel = finicityDefaultConfig.body.finicityAuto?.html?.auto?.showFirstModel == true ? true : false;
    finicityDefaultConfig.showActionLinks = finicityDefaultConfig.body.finicityAuto?.html?.auto?.showActionLinks == true ? true : false;
    finicityDefaultConfig.secure = finicityDefaultConfig.body.finicityAuto?.secure == true ? true : false;
    initOptions(finicityDefaultConfig.widget_service_api);
    const finicityDataHtml = !!finicityDefaultConfig.body['finicityAuto'] && !!finicityDefaultConfig.body['finicityAuto'].html ? finicityDefaultConfig.body['finicityAuto'].html : {};
    let options = initScript.methodWiseOption(
      finicityDefaultConfig.options.fincity_auto.method,
      {
        url: finicityDefaultConfig.options.fincity_auto.url,
        data: JSON.stringify(finicityDataHtml),
        contentType: "application/json; charset=UTF-8",
        dataType: "json",
      },
      finicityDefaultConfig.security_option,
    );
    options = encryptRequest(options);
    HttpRequest(options, (res) => {
      res= decryptResponse(res);
      res = typeof res === 'string' ? res : responseV2Interceptor(res, finicityDefaultConfig.slugs['fincity_auto'], false);
      initScript.getHTMLElementByDelimiter(finicityDefaultConfig.body['finicityAuto'].class).append(res);
      getIFrame();
    });
  };

  /**
   * getIFrame : open finicity model
   * @author Gaurav <gaurav.babu@biz2credit.com>
   */
  const getIFrame = () => {
    const finicityAuto = finicityDefaultConfig.body.finicityAuto;
    const params = {
      webhook: finicityAuto?.webhook,
      webhookData: finicityAuto?.webhookData,
    };
    let options = initScript.methodWiseOption(
      finicityDefaultConfig.options.openFinicityModel.method,
      {
        url: finicityDefaultConfig.options.openFinicityModel.url,
        data: JSON.stringify(params),
        contentType: "application/json; charset=UTF-8",
        dataType: "json",
        headers: {
          'Content-Type': 'application/json',
          'x-userid': finicityAuto.user_id,
          'x-username': finicityAuto.user_email,
        },
      },
      finicityDefaultConfig.security_option,
    );
    
    options = encryptRequest(options);
    HttpRequest(options, (res) => {
      res= decryptResponse(res);
      res = responseV2Interceptor(res, finicityDefaultConfig.slugs.openFinicityModel);
      if (res.partnerAuthenticationDataResponses.code == 200 && res.partnerAuthenticationDataResponses.status !== 400) {
        res = responseInterceptor(res);
        finicityDefaultConfig.finicityLink = res.partnerAuthenticationDataResponses.data.connect_url || '';
        finicityDefaultConfig.customer_id = res.partnerAuthenticationDataResponses.data.customer_id;
        bindEmitters();
        initScript.disableElementByProp('#finicityAutoBtnLinkAccount', false);
        if (!finicityDefaultConfig.showFirstModel) {
          openfinicityAutoModal();
        }
        initScript.toggleLoader(false);
      } else if (res.partnerAuthenticationDataResponses.code == 400 || res.partnerAuthenticationDataResponses.code == 404) {
        promiseResolve(res.partnerAuthenticationDataResponses);
        initScript.toggleLoader(false);
      } else {
        promiseResolve(res.partnerAuthenticationDataResponses);
        alert('Something went wrong with Finicity.\nPlease try again.');
      }
    });
  };

  /**
   * initOptions : initializing option config
   * @param API_URL string
   */
  const initOptions = (API_URL) => {
    finicityDefaultConfig.options = {
      fincity_auto: {
        url: !!finicityDefaultConfig['widget_service_slug_url'] ? finicityDefaultConfig['widget_service_slug_url'] : getV2URL(API_URL, 'fincity_auto', finicityDefaultConfig.slugs),
        method: 'POST',
      },
      openFinicityModel: {
        url: getV2URL(API_URL, 'openFinicityModel', finicityDefaultConfig.slugs),
        method: 'POST',
      },
      finicityTransactionIds: {
        url: getV2URL(API_URL, 'finicityTransactionIds', finicityDefaultConfig.slugs),
        method: 'POST',
      },
      submitFinicityForm: {
        url: getV2URL(API_URL, 'submitFinicityForm', finicityDefaultConfig.slugs),
        method: 'POST',
      },
    };
  };

  /**
   * openfinicityAutoModal : open-finicity-modal
   *
   * @author Gaurav <gaurav.babu@biz2credit.com>
   *
   */
  const openfinicityAutoModal = () => {
    if (!finicityDefaultConfig.finicityLink) return;
    finicityDefaultConfig.finicityAutoModal.show();
    $('body').addClass('modal-open');

    const config = finicityDefaultConfig.body.finicityAuto;
    const setFieldValue = (fieldName, value) => (document.getElementsByName(fieldName)[0].value = value);
    setFieldValue('url', encodeURI(finicityDefaultConfig.finicityLink));
    setFieldValue('caseid', config.app_id);
    setFieldValue('matchid', config.match_id);
    setFieldValue('customerid', config.user_id);
    setFieldValue('leadid', config.user_id);

    if (document.getElementsByName('jwtToken')[0]) {
      document.getElementsByName('jwtToken')[0].remove();
    }
    const finicityForm = document.getElementById('finicity_form');
    finicityForm.action = finicityDefaultConfig.body.finicityAuto?.action;
    finicityForm.submit();
  };

  /**
   * finicityAutoValidatorSuccess : finicityAutoValidatorSuccess
   */
  const finicityAutoValidatorSuccess = () => {
    openfinicityAutoModal();
  };

  /**
   * finicityAutoValidator : finicity auto validator with terms and condition
   */
  const finicityAutoValidator = () => {
    document.getElementById('doneMessageID').innerHTML = '';
    if (initScript.getObjectValueByString(finicityDefaultConfig, 'body.finicityAuto.html.terms_and_condition') && !!finicityDefaultConfig.body.finicityAuto.html['terms_and_condition'].flag)
      showTermsAndConditionModal();
    else finicityAutoValidatorSuccess();
  };

  /**
   * showTermsAndConditionModal : show terms and condition modal
   */
  const showTermsAndConditionModal = () => {
    initScript.addCSSAtTargetIdentifier('finicityManualTermsConditionSuccess', { display: 'block' });
  };

  /**
   * cancelfinicityTransaction : cancel finicity Transaction
   */
  const cancelfinicityTransaction = () => {
    finicityDefaultConfig.finicityAutoModal.hide();
    initScript.getTargetIdentifierElement('body')[0].classList.remove('modal-open');
    finicityDefaultConfig.finicity_error_modal_header.css('display', 'none');
    window.parent.postMessage('cancle-modal-first', '*');
  };

  /**
   * bindEmitters : binding event emitters
   * @author Gaurav <gaurav.babu@biz2credit.com>
   */

  const bindEmitters = () => {
    if (!finicityDefaultConfig.finicityLink) return alert('Something went wrong with Finicity.\nPlease try again.');
    finicityDefaultConfig.finicityAutoBtnLinkAccount = initScript.getHTMLElementByDelimiter('finicityAutoBtnLinkAccount', '#');
    finicityDefaultConfig.finicityAutoBtnLinkContinue = initScript.getHTMLElementByDelimiter('finicityAutoBtnLinkContinue', '#');
    finicityDefaultConfig.submitfinicityTransaction = initScript.getHTMLElementByDelimiter('submitfinicityTransaction', '#');
    finicityDefaultConfig.finicityAutoModal = initScript.getHTMLElementByDelimiter('finicityAutoModal', '#');
    finicityDefaultConfig.finicity_error_modal_header = initScript.getHTMLElementByDelimiter('finicity_error_modal_header');
    appendCSS();
    finicityDefaultConfig.finicityAutoBtnLinkAccount.on('click', () => {
      finicityAutoValidator();
    });

    finicityDefaultConfig.submitfinicityTransaction.on('click', () => {
      submitFinicityFormEvent();
    });
    initScript.getHTMLElementByDelimiter('cancelfinicityTransaction', '#').on('click', () => {
      cancelfinicityTransaction();
    });
    window.addEventListener('message', function (e) {
      if (e.type == 'message' && e.data.message == 'cancle-modal') {
        cancelfinicityTransaction();
        let cancleRes = { "status": "success", "code": 499, "data": e.data, "resource": "FINICITY"}
        promiseResolve(cancleRes);
      }
      if (!finicityDefaultConfig.showActionLinks) {
        if (e.type == 'message' && e.data.message == 'finicity-submitted') {
          submitFinicityFormEvent();
        }
      }
    });
  };

  /**
   * appendCSS : appending CSS with finicityConfigObj
   *
   * @author Gaurav <gaurav.babua@biz2credit.com>
   *
   */
  const appendCSS = () => {
    if (finicityDefaultConfig.body.finicityAuto.hasOwnProperty('css')) {
      const cssClassKeys = Object.keys(finicityDefaultConfig.body.finicityAuto.css);
      for (let i = 0; i < cssClassKeys.length; ++i) {
        const css = initScript.getStyleString(finicityDefaultConfig.body.finicityAuto.css[cssClassKeys[i]]);
        initScript.getHTMLElementByDelimiter(cssClassKeys[i]).attr('style', css);
      }
    }
  };

  /**
   * submitFinicityFormEvent : To handle final submit of finicity
   *
   * @author Gaurav <gaurav.babua@biz2credit.com>
   *
   */
  const submitFinicityFormEvent = () => {
    initScript.toggleLoader(true);
    const params = {
      customer_id: finicityDefaultConfig.customer_id,
      app_id: finicityDefaultConfig.body.finicityAuto?.app_id || '',
      user_id: finicityDefaultConfig.body.finicityAuto?.user_id || '',
      ach_details: finicityDefaultConfig.body.finicityAuto?.ach_details || false,
      owner_details: finicityDefaultConfig.body.finicityAuto?.owner_details || false,
      from_date: finicityDefaultConfig.body.finicityAuto?.from_date || '',
      to_date: finicityDefaultConfig.body.finicityAuto?.to_date || '',
      store_txn_in_db: finicityDefaultConfig.body.finicityAuto?.store_txn_in_db || false,
      consecutive_months: finicityDefaultConfig.body.finicityAuto?.consecutive_months || '',
      webhook_data: finicityDefaultConfig.body.finicityAuto?.webhookData,
    };
    let options = initScript.methodWiseOption(
      finicityDefaultConfig.options.finicityTransactionIds.method,
      {
        url: finicityDefaultConfig.options.finicityTransactionIds.url,
        data: JSON.stringify(params),
        contentType: "application/json; charset=UTF-8",
        dataType: "json",
        headers: {
          'Content-Type': 'application/json',
          'x-txn-duration-month': finicityDefaultConfig.body.finicityAuto?.txn_duration_in_month || 6,
        },
      },
      finicityDefaultConfig.security_option,
    );

    options = encryptRequest(options);
    HttpRequest(options, (res) => {
      res= decryptResponse(res);
      if (finicityDefaultConfig.showFirstModel) {
        initScript.getTargetIdentifierElement('#Failure').innerHTML = '';
      }
      res = responseV2Interceptor(res, finicityDefaultConfig.slugs.finicityTransactionIds);
      res = !!res && !!res.data ? res.data : res;
      if (res.finicity_transactions_data.code === 200) {
        let caseMappingFlag = finicityDefaultConfig.body.finicityAuto?.trigger_case_mapping || false;
        if (caseMappingFlag) {
          triggerCaseMapping(res);
        } else {
          submitFinicityForm(res);
        }
      } else if (res.finicity_transactions_data.code == 400 || res.finicity_transactions_data.code == 404) {
        initScript.toggleLoader(false);
        if (finicityDefaultConfig.showFirstModel) {
          displayModalHeaderWithMessage(Array.isArray(res.finicity_transactions_data.errors) ? res.finicity_transactions_data.errors[0].message : res.finicity_transactions_data.errors.message);
          finicityDefaultConfig.finicityAutoModal.innerHTML = '';
          finicityDefaultConfig.finicityAutoModal.css('display', 'none');
          document.getElementById('Failure').innerHTML = Array.isArray(res.finicity_transactions_data.errors)
            ? res.finicity_transactions_data.errors[0].message
            : res.finicity_transactions_data.errors.message;
          initScript.getHTMLElementByDelimiter('Failure', '#').css('display', 'block');
        }
        cancelfinicityTransaction();
        promiseResolve(res.finicity_transactions_data);
      } else {
        console.log(res.partnerAuthenticationDataResponses);
        cancelfinicityTransaction();
        promiseResolve(res.partnerAuthenticationDataResponses);
      }
    });
  };

  /**
   * submitFinicityForm : submit Finicity form
   *
   * @author Gaurav <gaurav.babua@biz2credit.com>
   *
   * @param finicityTransactionIdsResponse object
   */
  const submitFinicityForm = (finicityTransactionIdsResponse) => {
    if (finicityDefaultConfig.showFirstModel) {
      initScript.getTargetIdentifierElement('#doneMessageID').innerHTML = finicityDefaultConfig.body['success_message'] || 'Thanks for submitting your details, Please close the browser.';
      finicityDefaultConfig.finicityAutoModal.innerHTML = '';
      finicityDefaultConfig.finicityAutoModal.css('display', 'none');
    }
    initScript.disableElementByProp('#finicityAutoBtnLinkAccount', true);
    initScript.disableElementByProp('#finicity_auto', true);
    initScript.toggleLoader(false);
    cancelfinicityTransaction();
    promiseResolve(finicityTransactionIdsResponse.finicity_transactions_data);
  };

  /**
   * displayModalHeaderWithMessage : displaying expecting message on modal
   *
   * @author Gaurav <gaurav.babua@biz2credit.com>
   *
   * @param msg string
   */
  const displayModalHeaderWithMessage = (msg) => {
    finicityDefaultConfig.finicity_error_modal_header.text(msg);
    finicityDefaultConfig.finicity_error_modal_header.css('display', 'block');
  };

  /**
   * triggerCaseMapping : trigger case mapping
   *
   * @author Gaurav <gaurav.babu@biz2credit.com>
   *
   * @param finicityTransactionIdsResponse object
   */
  const triggerCaseMapping = (finicityTransactionIdsResponse) => {
    let options = initScript.methodWiseOption(
      finicityDefaultConfig.options.submitFinicityForm.method,
      {
        url: finicityDefaultConfig.options.submitFinicityForm.url,
        data: JSON.stringify({
          app_id: finicityDefaultConfig.body.finicityAuto?.app_id,
          user_id: finicityDefaultConfig.body.finicityAuto?.user_id,
          provider: finicityDefaultConfig.body.finicityAuto?.provider.auto,
          type: finicityDefaultConfig.body.finicityAuto?.type || 'bank-statement-auto',
          ref_id: finicityTransactionIdsResponse.finicity_transactions_data.data['transaction_ids'][0],
          response: finicityTransactionIdsResponse,
        }),
        contentType: "application/json; charset=UTF-8",
        dataType: "json",
        headers: {
          'Content-Type': 'application/json',
        },
      },
      finicityDefaultConfig.security_option,
    );
    options = encryptRequest(options);    
    HttpRequest(options, (res) => {
      res= decryptResponse(res);
      submitFinicityForm(finicityTransactionIdsResponse);
    });
  };

  const decryptResponse = (res) => {
    if (finicityDefaultConfig.secure) {
      res = { data: JSON.parse(secureGet('//htps12345nrfbw', atob(res.data))) };
    }
    return res;
    
  };
  const encryptRequest = (options) => {
    if (finicityDefaultConfig.secure) {
      options.url = options.url.replace('&internal=true', '');
      options.data = JSON.stringify({ data: btoa(secureSet('//htps12345nrfbw', options.data)) });
    }
    return options;   
  };
  const secureSet = (keys, value) => {
    const key = CryptoJS.enc.Utf8.parse(keys);
    const iv = CryptoJS.enc.Utf8.parse(keys);
    const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(value.toString()), key, {
      keySize: 128 / 8,
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.toString();
  };

  const secureGet = (keys, value) => {
    const key = CryptoJS.enc.Utf8.parse(keys);
    const iv = CryptoJS.enc.Utf8.parse(keys);
    const decrypted = CryptoJS.AES.decrypt(value, key, {
      keySize: 128 / 8,
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  };

  return {
    main,
    widgetPromise,
  };
})();
